export function AddBlockIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M5 6a3 3 0 00-3 3v6a3 3 0 003 3h6.083A6 6 0 1022 13.681V9a3 3 0 00-3-3H5zm7.757 6.757A5.973 5.973 0 0011.083 16H5a1 1 0 01-1-1V9a1 1 0 011-1h14a1 1 0 011 1v2.802a6.003 6.003 0 00-7.243.955zM21 17a1 1 0 01-1 1h-2v2a1 1 0 11-2 0v-2h-2a1 1 0 110-2h2v-2a1 1 0 112 0v2h2a1 1 0 011 1z"
      ></path>
    </svg>
  );
}
